import { createContext, useContext } from 'react';
import { IPermissionCheck } from '~/src/dash/utils/permission_service';
import { INavigationConfig } from '~/src/dash/views/common';

interface IBiddersListContext {
  cfg: INavigationConfig;
  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
  forceUpdate: (tabIndex: number) => void;
}

export const BiddersListContext = createContext({} as IBiddersListContext);
export const useBiddersListStore = (): IBiddersListContext => useContext(BiddersListContext);
